<template>
  <!--页头-->
  <div class="index_pc_head" :style="'background-image: url(' + filePath + '/nemojoyWebSiteFile/imgs/indexHead/indexHeadBac.png); background-repeat: no-repeat; background-size: 100% 100%;'">
    <div class="index_pc_head_logo">
      <router-link :to="'/'" draggable="false">
        <img :src="filePath + (logo || '/nemojoyWebSiteFile/imgs/indexHead/indexHeadLogo.png')" alt="" draggable="false">
      </router-link>
    </div>

    <div class="index_pc_head_mains">
      <template v-for="(head, index) in heads">
        <div :key="index">
          <!--下拉菜单-->
          <template v-if="head.child && head.child.length > 0">
            <div :span="head.span" class="head_child">
              <down_menu :item="head" />
            </div>
          </template>
          <!--外部链接-->
          <a v-else-if="head.u.startsWith('http://') || head.u.startsWith('https://')" :href="head.u">
            <div :span="head.span" :class="router_url === head.u ? 'head_active' : ''" class="index_pc_head_main">
              <div>{{ head.n }}</div>
            </div>
          </a>
          <!--内部链接-->
          <router-link v-else :to="head.u">
            <div :span="head.span" :class="router_url === head.u ? 'head_active' : ''" class="index_pc_head_main">
              <div>{{ head.n }}</div>
            </div>
          </router-link>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { get_head_data } from '@/api'
import vv from '@/components/varVariable'

export default {
  name: 'Head',
  data() {
    return {
      logo: '',
      heads: [],
      router_url: this.$route.path
    }
  },
  computed: {
    filePath() {
      return vv.fileHttp
    }
  },
  created() {
    get_head_data().then(d => {
      this.logo = d.logo
      this.heads = d.heads
    })
  }
}
</script>

<style lang="scss">
.big_screen{
  .index_pc_head{
    width: 100%;
    height: 84px;
    position: absolute;
    top: 0;
    z-index: 100;
    display: flex;
    justify-content: space-between;
    font-size: 18px;
    font-weight: bold;

    .index_pc_head_logo{
      width: 20%;
      height: 100%;
      img{
        max-width: 180px;
        padding-top: 18px;
        padding-left: 50px;
      }
    }

    .index_pc_head_mains{
      max-width: 70%;
      height: 100%;
      display: flex;
      justify-content: right;
      margin-right: 30px;

      .index_pc_head_main{
        width: 130px;
        height: 100%;
        color: rgb(141, 140, 140);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .head_child{
        width: 160px;
        height: 100%;
        color: rgb(141, 140, 140);
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .head_active{
        color: rgb(224, 15, 0);
      }

      .index_pc_head_main:hover{
        color: rgb(224, 15, 0);
      }
    }
  }
}

.small_screen{
  .index_pc_head{
    width: 100%;
    height: 50px;
    position: absolute;
    top: 0;
    z-index: 100;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    font-weight: bold;
    overflow: hidden;

    .index_pc_head_logo{
      height: 100%;
      img{
        margin-top: 12px;
        margin-left: 20px;
        height: 26px;
      }
    }

    .index_pc_head_mains{
      display: none;
    }
  }
}
</style>
